import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="section-padding py-20 px-6"
    >
      <div className="max-w-6xl mx-auto">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="section-title text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="text-cyan-400 font-mono text-lg">01.</span> About Me
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mb-12"></div>

          <Card className="glass-card bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl overflow-hidden hover:border-cyan-400/30 transition-all duration-300">
            <CardContent className="p-8 md:p-12">
              <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
                <p>
                  I'm a <span className="text-cyan-400 font-semibold">DevOps Engineer</span> and{' '}
                  <span className="text-cyan-400 font-semibold">Backend Developer</span> with over 5 years
                  of hands-on experience in automating, optimizing, and securing cloud deployments,
                  particularly in AWS environments.
                </p>
                <p>
                  Currently working as a <span className="text-cyan-400 font-semibold">System DevOps Engineer</span> at{' '}
                  <span className="text-white font-semibold">Nexent Bank N.V.</span> in Bucharest, Romania,
                  where I handle migrations, manage OCP and AAP pipelines, and create comprehensive logging and
                  monitoring systems using Elasticsearch, Nagios, Ansible, and Prometheus.
                </p>
                <p>
                  I'm proficient in building and maintaining robust backend systems with expertise in databases,
                  CI/CD pipelines, and Infrastructure as Code (IaC). I leverage tools like{' '}
                  <span className="text-cyan-400">Kubernetes</span>,{' '}
                  <span className="text-cyan-400">Docker</span>,{' '}
                  <span className="text-cyan-400">Jenkins</span>, and{' '}
                  <span className="text-cyan-400">Terraform</span> to enhance operational efficiency and
                  deliver scalable, reliable solutions.
                </p>
                <p>
                  Beyond my technical work, I'm passionate about knowledge sharing and community building. I've been 
                  a volunteer trainer for GNU/Linux System Administration and co-founded the Hacettepe University Free 
                  Software Society Students Chapter, organizing events and training sessions on various technologies.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;